import { ApplicantOfferResponseStatus, ApplicantResponseStatus, ApplicantOfferConditionType } from 'api-paths-cas';

export function getStatusByConditionType(
  applicantStatus?: ApplicantResponseStatus,
  conditionType?: ApplicantOfferConditionType,
): ApplicantOfferResponseStatus | undefined {
  if (!applicantStatus || !conditionType) return undefined;

  if (conditionType === ApplicantOfferConditionType.Conditional) {
    return applicantStatus.conditionStatus?.status;
  }

  if (conditionType === ApplicantOfferConditionType.Unconditional) {
    return applicantStatus.unConditionStatus?.status;
  }

  return undefined;
}
